function initSignupForms() 
{

    window.dataLayer = window.dataLayer || [];

    const homeCouponBookForm = document.querySelector('form._form_3'),
          homeCouponBookFormThankYou = document.querySelector('form._form_3 ._form-thank-you');

    if (typeof(homeCouponBookForm) != 'undefined' && homeCouponBookForm != null) {
            
        homeCouponBookForm.addEventListener('submit', function() {
            setTimeout(function() {

                if (window.getComputedStyle(homeCouponBookFormThankYou).display !== 'none') {

                    console.log('coupon book hit.');
                    window.dataLayer.push({
                        'event': 'email-signup-event',
                        'email-signup-type': 'coupon book',
                    });

                }

            }, 1000);
        });
    }

    const homeEmailSignupForm = document.querySelector('form._form_5'),
          homeEmailFormThankYou = document.querySelector('form._form_5 ._form-thank-you');

    if (typeof(homeEmailSignupForm) != 'undefined' && homeEmailSignupForm != null) {

        homeEmailSignupForm.addEventListener('submit', function() {
            setTimeout(function() {

                if (window.getComputedStyle(homeEmailFormThankYou).display !== 'none') {

                    console.log('email form hit.');
                    window.dataLayer.push({
                        'event': 'email-signup-event',
                        'email-signup-type': 'newsletter',
                    });

                }

            }, 1000);
        });
    }

    const couponBookForm = document.querySelector('form._form_23'),
          couponBookFormThankYou = document.querySelector('form._form_23 ._form-thank-you');

    if (typeof(couponBookForm) != 'undefined' && couponBookForm != null) {

        couponBookForm.addEventListener('submit', function() {
            setTimeout(function() {

                if (window.getComputedStyle(couponBookFormThankYou).display !== 'none') {

                    console.log('coupon book hit.');
                    window.dataLayer.push({
                        'event': 'email-signup-event',
                        'email-signup-type': 'coupon book',
                    });

                }

            }, 1000);
        });
    }
}

export default function init() {

    initSignupForms();

}